import Badge from "ds/components/Badge";
import { BadgeVariants } from "ds/components/Badge/types";
import { WebhookDelivery } from "types/generated";

import styles from "./Status.module.css";

enum NetworkStatuses {
  Ok = "Ok",
  Redirect = "Redirect",
  Error = "Error",
  Special = "Special",
}

const NETWORK_STATUSES: Record<NetworkStatuses, BadgeVariants> = {
  [NetworkStatuses.Ok]: "green",
  [NetworkStatuses.Error]: "red",
  [NetworkStatuses.Redirect]: "yellow",
  [NetworkStatuses.Special]: "gray",
};

const translateStatus = (status: number): BadgeVariants => {
  if (status === 0) {
    return NETWORK_STATUSES[NetworkStatuses.Special];
  }

  if (status >= 200 && status < 300) {
    return NETWORK_STATUSES[NetworkStatuses.Ok];
  }

  if (status >= 300 && status < 400) {
    return NETWORK_STATUSES[NetworkStatuses.Redirect];
  }

  if (status >= 400 && status < 600) {
    return NETWORK_STATUSES[NetworkStatuses.Error];
  }

  return NETWORK_STATUSES[NetworkStatuses.Special];
};

type WebhookDeliveriesStatusProps = {
  status: WebhookDelivery["status"];
};

const WebhookDeliveriesStatus = ({ status }: WebhookDeliveriesStatusProps) => {
  return (
    <Badge
      className={styles.statusBadge}
      text={`${status}`}
      variant={translateStatus(status)}
      type="strong"
    />
  );
};

export default WebhookDeliveriesStatus;
